import { parsePrice } from 'src/utils/parsePrice.ts';
import { getRawAttributeValue } from 'src/utils/getRawAttributeValue.ts';
import { AttributesClass } from 'src/generated/operations.ts';

export const getPriceValue = <T extends AttributesClass>(
    item: T,
    shoppingCenter: keyof T,
    currency: string | null,
): { currency: string; value: number} => parsePrice(getRawAttributeValue(
    item,
    currency ? `${String(shoppingCenter)}_${currency}` as keyof typeof item : shoppingCenter,
    getRawAttributeValue(item, shoppingCenter),
));
